import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  CheckInvoiceIsraelTokenRequest,
  CheckInvoiceIsraelTokenResponse,
  CompleteIsraelInvoiceAuthRequest,
  CompleteIsraelInvoiceAuthResponse,
} from "../../models/IsraelInvoice.model";
import { IsraelInvoiceService } from "../../services/IsraelInvoiceService";

export const checkInvoiceIsraelToken = createAsyncThunk<
  CheckInvoiceIsraelTokenResponse,
  CheckInvoiceIsraelTokenRequest,
  { rejectValue: string }
>("israelInvoice/checkToken", async (requestData, { rejectWithValue }) => {
  try {
    const data = await IsraelInvoiceService.checkToken(requestData);
    return data;
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : "שגיאה לא ידועה";
    return rejectWithValue(message);
  }
});

export const completeIsraelInvoiceAuthorization = createAsyncThunk<
  CompleteIsraelInvoiceAuthResponse,
  CompleteIsraelInvoiceAuthRequest,
  { rejectValue: string }
>(
  "israelInvoice/completeAuthorization",
  async (requestData, { rejectWithValue }) => {
    try {
      const data =
        await IsraelInvoiceService.completeAuthorization(requestData);

      if (!data.success) {
        return rejectWithValue(data.message || "שגיאה בהשלמת ההזדהות");
      }

      return data;
    } catch (error: unknown) {
      const message = error instanceof Error ? error.message : "שגיאה לא ידועה";
      return rejectWithValue(message);
    }
  },
);
